import { Skeleton, Stack, styled } from "@mui/material";
import React from "react";

const TopUserHeader = styled(Skeleton)(
    ({ theme }) => `
        width: 100%;
        height: 60px;
        borderRadius: 8px; 
    `
)

const TopUserBody = styled(Skeleton)(
    ({ theme }) => `
        width: 100%;
        height: 200px;
        borderRadius: 8px; 
    `
)


export function TopUsersLoader() {

    return (
        <Stack spacing={2} sx={{width: "100%", p: "1rem"}}>
            <TopUserHeader variant="rounded" />
            <TopUserBody variant="rounded" />
        </Stack>
    )
}